import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IMultiTabTable, STRING } from '../../types';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-multi-tab-table',
  templateUrl: './multi-tab-table.component.html',
  styleUrls: ['./multi-tab-table.component.css']
})
export class MultiTabTableComponent implements OnInit {

	constructor(
		private activatedRoute: ActivatedRoute,
		private router: Router,
	) { }
	@Input() data: IMultiTabTable;
	@Input() resetButton = false;
	@Output() filterChangeSelect = new EventEmitter();
	formLoaded = false;
	@Output() filter = new EventEmitter();
	@Output() pageNumberChange = new EventEmitter();
	@Output() recordsPerPageChange = new EventEmitter();
	@Output() tabChange = new EventEmitter();

	ngOnInit() {
		this.activatedRoute.queryParams
			.subscribe(params => {
				const tabId = params.tab || this.activeTab;
				if (tabId) {
					this.onTabChange(tabId);
				}
			});

		this.formLoaded = true;
	}

	onFilter(appliedFilter, tabId) {
		this.filter.emit({
			appliedFilter,
			tabId
		});
	}

	onSelectFilterChange(event) {
		this.filterChangeSelect.emit(event)
	}

	onPageNumberChange(pageNo, tabId) {
		this.pageNumberChange.emit({
			pageNo,
			tabId
		});
	}

	appendTabInInUrl() {

		this.router.navigate([], {
			relativeTo: this.activatedRoute,
			queryParams: {
				tab: this.activeTab
			},
			queryParamsHandling: 'merge',
		});
	}

	switchTab(tabId) {
		const selectedTab = this.data.tabs.find(t => t.id === tabId);
		if (selectedTab) {
			this.activeTab = tabId;
			this.appendTabInInUrl();
		}
	}

	onTabChange(tabId) {
		const selectedTab = this.data.tabs.find(t => t.id === tabId);
		if (selectedTab) {
			selectedTab.table.pagination.pageNum = 1
			this.activeTab = tabId;
			this.tabChange.emit(tabId);
			if (typeof selectedTab.onSelect === STRING.FUNCTION) {
				selectedTab.onSelect();
			}
		}
	}

	get onlyTable(){
		return !this.data || !this.data.label;
	}

	set activeTab(tabId: string) {
	  this.data.tabs.forEach(tab => {
		  tab.active = tab.id === tabId ? true : false;
	  });
  	}

	get activeTab() {
		const activeTab = this.data.tabs.find( t => t.active === true);
		if (activeTab) {
			return activeTab.id;
		}
	}

	onRecordsPerPageChange(recordsPerPage, tabId) {
		this.recordsPerPageChange.emit({
			recordsPerPage,
			tabId
		});
	}

}
